export const QUERY_KEYS = {
  projectFolder: "DOCUMENT_LIBRARY_PROJECT_FOLDER",
  folderItems: "DOCUMENT_LIBRARY_FOLDER_ITEMS",
  itemVersions: "DOCUMENT_LIBRARY_ITEM_VERSIONS"
};

/**
 * Size of each upload-session PUT. Graph requires every non-final chunk to be
 * a multiple of 320 KiB (327,680 bytes) — 10 MiB is exactly 32 of those.
 */
export const UPLOAD_CHUNK_SIZE = 10 * 1024 * 1024;
